import styled from '@emotion/styled';
import { InputBase } from '@mui/material';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { useCallback, useMemo } from 'react';
import FlagIcon from './FlagIcon';

const customStyles = {
  select: {
    // Style for the Select component
    display: 'flex',
    alignItems: 'center',
    // color: `${theme.palette.immersightGrey.main} !important`,
    color: 'grey'
  },
  menuItem: {
    // Style for the MenuItem component
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    // color: `${theme.palette.immersightGrey.main} !important`,
    color: 'grey'
  },
  label: {
    // Style for the language label
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
  },
  box: {
    // Style for the container Box
    paddingLeft: 2,
    display: 'flex',
    alignItems: 'center',
  },
};

const CustomInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    // Style for the Select component
    display: 'flex !important',
    alignItems: 'center',
    borderRadius: 4,
    position: 'relative',
    fontSize: 16,
    color: 'black',
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));

// An array of objects representing available languages 
// Check https://github.com/madebybowtie/FlagKit/blob/master/Assets/Flags.md for all flag codes 
const regionOptions = [
  { code: 'DE', label: 'DE', flag: 'DE' },
  { code: 'CH', label: 'CH', flag: 'CH' },
  { code: 'GB', label: 'GB', flag: 'GB' },
  { code: 'US', label: 'US', flag: 'US' },
  { code: 'GLOBAL', label: 'GLOBAL', flag: 'UN' }
];

function RegionPicker({ region, setRegion, regionsToHide, isStatic = false }) {

  // Define a memoized callback function to handle region changes
  const handleRegionChange = useCallback((event) => {
    setRegion(event.target.value);
  }, [setRegion]);

  const menuItems = useMemo(() => {
    let options = [...regionOptions];
    if (regionsToHide) {
      options = options.filter(op => !regionsToHide.includes(op.code));
    }
    return options.map(({ code, label, flag }) => (
      <MenuItem key={code} value={code} sx={customStyles.menuItem}>
        <FlagIcon code={flag} sx={customStyles.icon} />
        <Typography variant="body1" sx={customStyles.label}>{label}</Typography>
      </MenuItem>
    ));
  }, [customStyles, regionsToHide]);

  return (
    <Box sx={customStyles.box} >
      <Select
        // Set the value of the Select component to the currently selected region
        value={region}
        // Call the handleRegionChange callback when the region is changed
        onChange={handleRegionChange}
        input={<CustomInput />}
        // Remove the border from the outlined input
        sx={{
          '.MuiOutlinedInput-notchedOutline': {
            border: 0
          },
          display: "flex !important",
          alignItems: "center",
        }}
        disabled={isStatic}
      >
        {menuItems}
      </Select>
    </Box>
  );
}

export default RegionPicker;
